import {message, Modal} from 'antd'
import {bulkMarkDoneOrderByIds} from "../../../../../services/api/3dApi"

const bulkMarkAsDone = async (ids) => {
    const payload = {
        ids,
    }

    const {data: response} = await bulkMarkDoneOrderByIds(payload)

    const {success, error} = response

    if (!success) {
        throw new Error(error)
    }

    return true
}

export default function (ids, onSuccess, onReset) {
    Modal.confirm({
        title: 'Bạn chắc chắn đánh dấu hoàn thành các orders được chọn ?',
        okText: 'Đồng ý',
        cancelText: 'Hủy',
        onOk() {
            const result = bulkMarkAsDone(ids)

            result.then(res => {
                if (res === true) {
                    message.success('Thành công!')
                    onReset()
                    onSuccess()
                }
            }).catch(err => {
                message.error(err.message, 3)
            })
        }
    })
}
